module.exports = __webpack_public_path__ + "media/images/color_admin_v3/logo-d59084246c2b3ce74d3c14122005f217.png";